import { Box, Button, ButtonProps, Heading, VStack } from '@chakra-ui/react'
import { NextLink } from '@src/components/sco/utilities/NextLink'

type EducationErrorStateProps = {
  errorCode?: number
  ctaButtonProps?: ButtonProps
  ctaLabel?: string
  ctaHref?: string
  headingText?: string
}

export const EducationErrorState = (props: EducationErrorStateProps) => {
  const headingText = props.headingText || 'Content not found.'
  const ctaLabel = props.ctaLabel || 'Explore'
  const ctaButtonProps = props.ctaButtonProps || {}
  const ctaHref = props.ctaHref || '/education'

  return (
    <VStack align={'center'} gap={4} justify={'center'} padding={'4em'} width={'full'}>
      <Heading fontSize={'1.5em'}>{headingText}</Heading>
      <Box>
        <NextLink href={ctaHref} prefetch={false}>
          <Button {...ctaButtonProps}>{ctaLabel}</Button>
        </NextLink>
      </Box>
    </VStack>
  )
}
